export default __webpack_public_path__ + "static/media/ic-instruction-02.3251ec03.svg";